<template>
    <div class="voice-bar">
        <aplayer :music="{title: title, artist: artist, src: src, pic: cover}" theme="#d0a95f" repeat="no-repeat" preload="auto" />
    </div>
</template>

<script>
  import Aplayer from 'vue-aplayer';

  export default {
    name: 'VoiceBar',
    components: {
      Aplayer
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      artist: {
        type: String,
        default: 'artist'
      },
      src: {
        type: String,
        require: true
      },
      cover: {
        type: String,
        require: true
      }
    }
  };
</script>

<style scoped lang="less">
    .voice-bar {
        position: fixed;
        left: 0;
        bottom: -30px;
        padding-left: 30px;
        /deep/ .aplayer {
            height: 60px;
            margin-bottom: 10px;
            overflow: visible;
            background-color: #000000c7;

            .aplayer-music {
                display: none;
            }

            .aplayer-pic {
                border-radius: 50%;
                border: 3px solid #d0a95f;
                /*margin-top: -6px;*/
                /*margin-left: -30px;*/
                margin-top: -90px;
                margin-left: -25px;
                .aplayer-play, .aplayer-pause {
                    border: none;
                    width: 33px;
                    height: 33px;
                    button {
                        width: 30px;
                        height: 30px;
                    }
                }
                .aplayer-pause {
                    left: 15px;
                    top: 15px;
                }
            }
            .aplayer-controller {
                margin-top: 10px;
                .aplayer-time {
                    width: 100%;
                    .aplayer-time-inner {
                        width: 100%;
                        color: #000000c7;
                    }
                    .aplayer-ptime {
                        position: absolute;
                        left: 0;
                        color: white;
                    }
                    .aplayer-dtime {
                        position: absolute;
                        right: 0;
                        color: white;
                    }
                    .aplayer-icon.inactive {
                        display: none;
                    }
                }
            }

            .aplayer-bar-wrap {
                position: absolute;
                width: 70%;
                margin-left: 45px;
                height: 4px;
                z-index: 999;
                .aplayer-bar, .aplayer-loaded, .aplayer-played {
                    height: 4px;
                }
                .aplayer-thumb {
                    margin-top: -6px;
                    width: 15px;
                    height: 15px;
                }
            }
        }
    }
</style>